import { NgModule } from '@angular/core';
import { FiltersDesktopComponent } from './filters-desktop.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
	declarations: [FiltersDesktopComponent],
	imports: [SharedModule],
	exports: [FiltersDesktopComponent],
})
export class FiltersDesktopModule {}
